import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=d88c80ca&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=d88c80ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88c80ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d88c80ca')) {
      api.createRecord('d88c80ca', component.options)
    } else {
      api.reload('d88c80ca', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=d88c80ca&scoped=true&", function () {
      api.rerender('d88c80ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u1eON4XuzoIb/JS/comp/PopupBox.vue"
export default component.exports